import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALBRIDGE,
  DELETE_LEGALBRIDGE,
  UPDATE_LEGALBRIDGE,
  ADD_NEW_LEGALBRIDGE,
} from "./actionType";

import {
  getLegalBridgeSuccess,
  getLegalBridgeFail,
  deleteLegalBridgeSuccess,
  deleteLegalBridgeFail,
  updateLegalBridgeSuccess,
  updateLegalBridgeFail,
  addLegalBridgeSuccess,
  addLegalBridgeFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLegalBridgeApi,
  updateLegalBridgeApi,
  deleteLegalBridgeApi,
  addNewLegalBridgeApi
} from "../../helpers/backend_helper";

function* getLegalBridge({ payload: legalBridge }) {
  try {
    const response = yield call(getLegalBridgeApi, legalBridge);
    yield put(getLegalBridgeSuccess(GET_LEGALBRIDGE, response.data));
  } catch (error) {
    yield put(getLegalBridgeFail(GET_LEGALBRIDGE, error));
  }
}

function* onUpdateLegalBridge({ payload: legalBridge }) {
  try {
    const response = yield call(updateLegalBridgeApi, legalBridge);
    yield put(updateLegalBridgeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateLegalBridgeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalBridge({ payload: legalBridge }) {
  try {
    const response = yield call(deleteLegalBridgeApi, legalBridge);
    yield put(deleteLegalBridgeSuccess({ legalBridge, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalBridgeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalBridge({ payload: legalBridge }) {
  try {
    const response = yield call(addNewLegalBridgeApi, legalBridge);
    yield put(addLegalBridgeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalBridgeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalBridge() {
  yield takeEvery(GET_LEGALBRIDGE, getLegalBridge);
}

export function* watchUpdateLegalBridge() {
  yield takeEvery(UPDATE_LEGALBRIDGE, onUpdateLegalBridge);
}

export function* watchDeleteLegalBridge() {
  yield takeEvery(DELETE_LEGALBRIDGE, onDeleteLegalBridge);
}

export function* watchAddNewLegalBridge() {
  yield takeEvery(ADD_NEW_LEGALBRIDGE, onAddNewLegalBridge);
}

function* legalBridgeSaga() {
  yield all([
    fork(watchGetLegalBridge),
    fork(watchDeleteLegalBridge),
    fork(watchUpdateLegalBridge),
    fork(watchAddNewLegalBridge)
  ]);
}

export default legalBridgeSaga;
